import styles from '@/shared/styles/MainPage.module.css';
import Image from 'next/image';
import { Roboto } from 'next/font/google';
import cn from 'classnames';

const roboto = Roboto({
  subsets: ['cyrillic', 'latin'],
  weight: ['700', '400'],
});

interface Props {}

const MainPage: React.FC<Props> = () => {
  return (
    <div className={cn(styles.container, roboto.className)}>
      <Image src="/payment-card.svg" width={250} height={250} alt="Иконка платежной карты" priority />
    </div>
  );
};

export default MainPage;
